var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { injectable } from 'tsyringe';
import { MolJob } from 'packages/old_mol/entities/MolJob';
import PathBuilder from 'packages/core/PathBuilder';
import { EntityBuilder } from '@decahedron/entity';
var MolListingRepository = /** @class */ (function (_super) {
    __extends(MolListingRepository, _super);
    function MolListingRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = MolJob;
        _this.url = 'api/v2/jobs/:jobId/mol';
        return _this;
    }
    MolListingRepository.prototype.createListing = function (jobId, listing) {
        return this.create(listing, { jobId: jobId });
    };
    MolListingRepository.prototype.updateListing = function (listing) {
        return this.put(this.url, listing, { jobId: listing.jobId });
    };
    MolListingRepository.prototype.getListingForJobId = function (jobId) {
        var _this = this;
        return this.get(this.url, { jobId: jobId })
            .then(function (response) { return EntityBuilder.buildOne(MolJob, _this.responseTransformer(response).data); });
    };
    MolListingRepository.prototype.removeListingForJob = function (jobId) {
        return this.axios.delete(PathBuilder(this.url, { jobId: jobId }));
    };
    MolListingRepository = __decorate([
        injectable()
    ], MolListingRepository);
    return MolListingRepository;
}(AbstractRepository));
export { MolListingRepository };
